module.exports = __webpack_public_path__ + "static/media/digdesa_logo.58e29947.png";